import { useApi } from "@/hooks/useApi";

import { transformData } from "@/utils/transformData";
import { paginatedProductsMap } from "@/utils/mappings/paginatedProducts";
import { ProductType } from "@/enums/ProductType";

import { Additional, ReactSelect, ReactSelectProps } from "@/components/Selects/ReactSelect";

type Props = ReactSelectProps;

type Medication = {
	id: number;
	name: string;
	description: string;
};

type TransformedPaginatedMedications = TransformedGenericPagination<Medication>;

export function MedicationsSelect({ ...rest }: Props) {
	const { api } = useApi();

	async function handleGetMedications(page?: number, search?: string) {
		try {
			const currentSearchLength = search?.length || 0;

			if (currentSearchLength > 0 && currentSearchLength < 3) {
				return {} as TransformedPaginatedMedications;
			}

			const { data } = await api.get("/products/search-by-type", {
				params: {
					types: [ProductType.Medicine],
					page: page || 1,
					search,
				},
			});

			const transformedMedications = transformData<TransformedPaginatedMedications>(
				data,
				paginatedProductsMap
			);

			return transformedMedications;
		} catch (error) {
			console.log(error);
			return {} as TransformedPaginatedMedications;
		}
	}

	const loadAsyncMedicationsOptionsProps = {
		additional: {
			page: 1,
		},
		isAsyncPaginate: true,
		async loadOptions(search: string, _: Medication, { page }: Additional) {
			const medications = await handleGetMedications(page, search);

			return {
				options: medications?.results.map((medication) => ({
					value: medication.id,
					label: medication.description.trim(),
				})),
				hasMore: medications.meta?.currentPage < medications.meta?.lastPage || false,
				additional: {
					page: page + 1,
				},
			};
		},
	};

	return (
		<ReactSelect
			isSolid
			noOptionsMessage={({ inputValue }) => {
				if (inputValue.length > 0 && inputValue.length < 3) {
					return "Digite pelo menos 3 caracteres";
				}

				return "Nenhum medicamento encontrado";
			}}
			{...loadAsyncMedicationsOptionsProps}
			{...rest}
		/>
	);
}
